import { useState, useEffect } from "react";
import { ExpandedContent, Separator } from "../../Compartilhado/styles";
import { IItemHistorico } from "../../../../types";
import { DadosAnexoAdicionado } from "./types";
import { mapearDadosAnexoAdicionado } from "./utils";
import BlocoAnexos from "../../Compartilhado/Blocos/BlocoAnexos";
import LogsVazio from "../../Compartilhado/LogsVazio";
import api from "../../../../../../../services/api";

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentAnexoAdicionado({ item, onNavigateToFile }: ExpandedContentProps) {
    const [dados, setDados] = useState<DadosAnexoAdicionado | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!item.id) {
            setLoading(false);
            return;
        }

        const buscarDados = async () => {
            try {
                setLoading(true);
                const response = await api.get(`log-historico/${item.id}`);

                if (response.data.status === 'success') {
                    const logs = response.data.result || [];
                    const dadosProcessados = mapearDadosAnexoAdicionado(logs);
                    setDados(dadosProcessados);
                }
            } catch (error: any) {
                console.error('Erro ao buscar dados do histórico:', error);
                setDados(null);
            } finally {
                setLoading(false);
            }
        };

        buscarDados();
    }, [item.id]);

    if (loading) {
        return (
            <ExpandedContent>
                <div style={{ padding: '20px', textAlign: 'center', color: 'var(--c64748b)' }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (!dados || dados.anexos.length === 0) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    return (
        <ExpandedContent>
            <Separator />
            <BlocoAnexos anexos={dados.anexos} onNavigateToFile={onNavigateToFile} />
        </ExpandedContent>
    );
}

